import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Loader2, CheckCircle2, CreditCard } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export default function PayLink() {
  const { linkId } = useParams();
  const [link, setLink] = useState(null);
  const [error, setError] = useState("");
  const [working, setWorking] = useState(false);

  useEffect(() => {
    api.get(`/pay/${linkId}`).then((r) => setLink(r.data)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [linkId]);

  const pay = async () => {
    setWorking(true);
    try {
      const { data } = await api.post(`/pay/${linkId}/checkout`);
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); setWorking(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="pay-page">
      <div className="text-center mb-8">
        <span className="inline-flex w-12 h-12 rounded-sm bg-gold items-center justify-center font-display font-black text-navy-950">10X</span>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-100 mt-5">MEMBERSHIP PAYMENT</h1>
        <p className="text-sm text-slate-500 mt-2">Secure payment link from 10XGLOBAL.</p>
      </div>
      <div className="card-surface p-7" data-testid="pay-card">
        {error ? (
          <div className="text-center" data-testid="pay-error">
            <p className="text-sm text-red-400">{error}</p>
            <Link to="/contact" className="btn-outline mt-6 inline-flex" data-testid="pay-contact-btn">CONTACT SUPPORT</Link>
          </div>
        ) : !link ? (
          <div className="flex justify-center py-8 text-slate-500"><Loader2 size={18} className="animate-spin" /></div>
        ) : link.status === "PAID" ? (
          <div className="text-center" data-testid="pay-paid-panel">
            <CheckCircle2 size={40} className="text-emerald-400 mx-auto mb-4" />
            <p className="font-display text-lg font-bold text-slate-100">PAYMENT COMPLETED</p>
            <p className="text-sm text-slate-400 mt-2">This payment link has already been paid. Membership will be activated after confirmation.</p>
          </div>
        ) : (
          <>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between border-b border-slate-800 pb-3"><span className="text-slate-500 font-mono text-[10px] uppercase tracking-widest">Company</span><span className="text-slate-100 font-semibold" data-testid="pay-company">{link.company_name}</span></div>
              <div className="flex justify-between border-b border-slate-800 pb-3"><span className="text-slate-500 font-mono text-[10px] uppercase tracking-widest">Plan</span><span className="text-gold font-semibold" data-testid="pay-plan">{link.plan}</span></div>
              <div className="flex justify-between border-b border-slate-800 pb-3"><span className="text-slate-500 font-mono text-[10px] uppercase tracking-widest">Amount</span><span className="text-slate-100 font-bold font-mono" data-testid="pay-amount">₹{Number(link.amount).toLocaleString("en-IN")}</span></div>
            </div>
            <button onClick={pay} disabled={working} data-testid="pay-now-btn" className="btn-gold w-full mt-7 disabled:opacity-60">
              {working ? <Loader2 size={15} className="animate-spin" /> : <><CreditCard size={15} /> PAY NOW</>}
            </button>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-[11px] text-slate-600 font-mono"><ShieldCheck size={12} /> Secured by Stripe · 10XGLOBAL</p>
          </>
        )}
      </div>
    </div>
  );
}
